import {VisitRequestDto} from "./VisitRequestDto";
import {VisitorAccessLogDto} from "./VisitorAccessLogDto";
import {RequestVisitorAttachFile} from "./RequestVisitorAttachFile";
import {VisitorDriveType} from "../enums/VisitorDriveType";

export class RequestVisitorDto {
    id: string = '';
    requestId: string = '';
    fullName: string = '';
    firstName: string = '';
    lastName: string = '';
    mobile: string = '';
    email: string = '';
    portraitFileId: string = '';
    photoUrl: string = '';
    company: string = '';
    idType: string = '01';
    status: string = '00';

    idNumber: string = '';
    visitCode: string = '';
    accessCardNumber: string = '';
    accessCode: string = '';
    accessCodeCounter: string = '';
    checkOutPermission: number = 0;
    visitorType: string = '01';
    carryGoods: string = '';
    job: string = '';
    driveType: string = VisitorDriveType.Enum.None;
    plateNumber: string = '';
    plateNumberColor: string = '';
    vehicleUseType: string = '';
    vehicleType: string = '';
    vehicleRegistrationDate: string = '';
    vehicleFuelType: string = "";
    vehicleEmissionStandard: string = "";
    driverLicenseNumber: string = '';
    lastTrainingDate: string = '';
    haveMeal: string = '';
    wxOpenId: string = '';
    wxUnionId: string = '';
    consentLetterFileId: string = '';
    constructionOrderNumber: string = '';

    visitRequest?: VisitRequestDto;
    checkInLog?: VisitorAccessLogDto;
    checkOutLog?: VisitorAccessLogDto;
    accessInLog?: VisitorAccessLogDto;
    accessOutLog?: VisitorAccessLogDto;
    attachFilesArray: Array<RequestVisitorAttachFile> = [];
    attachFiles: string = '';
    remarks:string = '';//作为员工编号
}